/**
 * Dev-only logger helpers.
 *
 * `devLog` and `devWarn` are stripped from production bundles via the
 * `import.meta.env.DEV` guard - Vite tree-shakes the call sites when
 * building for production, so we keep verbose diagnostics in dev without
 * polluting the browser console in prod.
 *
 * `logError` always fires - errors matter in production too.
 */

export const devLog = (...args: unknown[]) => {
    if ((import.meta as any).env.DEV) console.log(...args);
};

export const devWarn = (...args: unknown[]) => {
    if ((import.meta as any).env.DEV) console.warn(...args);
};

// Errors always log - they matter in prod too
export const logError = (...args: unknown[]) => console.error(...args);
